import serverFetch from "../utils/serverFetch";
import config from "../app-config";

export const fetch_all_permissions = async () => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/permissions`,
        method: "GET",
    }))
}
